import React, { useEffect, useState } from "react";
import InactivityModal from "./InactivityModal";
import moment from "moment";

const InactivityModalHandler = (props) => {
  const [showModal, setShowModal] = useState(false);

  let timer = undefined;

  const events = ["click", "keydown"];

  const eventHandler = (eventType) => {
    localStorage.setItem("lastInteractionTime", moment());
    if (timer) {
      props.onActive();
      startTimer();
    }
  };

  const startTimer = () => {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(
      () => {
        let lastInteractionTime = localStorage.getItem("lastInteractionTime");
        const diff = moment.duration(
          moment().diff(moment(lastInteractionTime))
        );
        let timeOutInterval = props.timeOutInterval
          ? props.timeOutInterval
          : 60000;
        if (diff._milliseconds < timeOutInterval) {
          startTimer();
          props.onActive();
        } else {
          props.onIdle();
          setShowModal(true);
        }
      },
      props.timeOutInterval ? props.timeOutInterval : 60000
    );
  };

  const addEvents = () => {
    events.forEach((eventName) => {
      window.addEventListener(eventName, eventHandler);
    });

    startTimer();
  };

  const removeEvents = () => {
    events.forEach((eventName) => {
      window.removeEventListener(eventName, eventHandler);
    });
  };

  useEffect(() => {
    addEvents();

    return () => {
      removeEvents();
      clearTimeout(timer);
    };
  });

  const handleContinueSession = () => {
    setShowModal(false);
  };

  return (
    <div>
      <InactivityModal
        showModal={showModal}
        handleContinue={handleContinueSession}
      />
    </div>
  );
};

export default InactivityModalHandler;
